import React, { useEffect, useState } from 'react'
import { Row, Col, Layout } from 'antd'
import { connect } from 'react-redux'

import { changeRoute } from 'store/actions/login'
import { useActions } from '../../hooks/useActions'
import BankInfo from './components/BankInfo'
import SideBar from './components/Sidebar'
import ProgressBar from 'components/Progressbar'
import { secureLocalStorageRemove } from '../../helpers/index'
import 'antd/dist/antd.css'
import useResponsiveWidth from 'hooks/useResponsiveWidth'

import './login.scss'

const LoginPage: React.FC<any> = ({ inProgress, inProgressAsan, tabValue, value }) => {
  const { changeRoute } = useActions()
  const [progress, setProgress] = useState(false)
  const responsiveWidth = useResponsiveWidth();

  useEffect(() => {
    // localStorage.clear()
    localStorage.removeItem("auth_token")
    localStorage.removeItem("auth_token_verifyed")
    secureLocalStorageRemove("value")
    secureLocalStorageRemove("username")
    secureLocalStorageRemove("channel")
    secureLocalStorageRemove("currentCompany")
    secureLocalStorageRemove("userData")
    secureLocalStorageRemove("permissions")
    secureLocalStorageRemove("rol")
    secureLocalStorageRemove("phoneNumber")
    changeRoute(0)
  }, [])


  useEffect(
    () => {
      if (inProgress || inProgressAsan) {
        let timer = setTimeout(() => setProgress(true), 100);
        return () => {
          setProgress(false)
          clearTimeout(timer);
        }
      }
    },
    [inProgress, inProgressAsan, tabValue]
  )

  return (
    <Layout>
      {/* <ProgressBar seconds={8} inProgress={true}/> */}
      {(inProgress || inProgressAsan) && value == 0 && <ProgressBar seconds={8} inProgress={progress} />}
      <Row>
        {
          responsiveWidth > 992 &&
          <Col className="login-data">
            <BankInfo />
          </Col>
        }

        <Col className="login-form-card">
          <SideBar />
        </Col>
      </Row>
    </Layout>
  )
}
const mapDispatchToProps = { changeRoute }

const mapStateToProps = (state: any) => ({
  inProgress: state.googleAuth.inProgress,
  isProgress: state.googleAuth.isProgress,
  inProgressAsan: state.token.inProgress,
  tabValue: state.login.tabValue,
  value: state.login.value
})
export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)
